'use client'
import { memo, useState, useCallback, ReactNode } from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const ACCORDION_SX = {
  width: '100%',
  borderRadius: 5,
  boxShadow: 'none',
  border: '1px solid #ccc',
  ':before': { display: 'none' },
}

interface AccordionUsageProps {
  title: string | ReactNode
  subtitle?: ReactNode
  expanded?: boolean
  [key: string]: any
}

function AccordionUsage({ title, subtitle, expanded, ...rest }: AccordionUsageProps) {
  const [expandedAcc, setExpandedAcc] = useState(Boolean(expanded))
  const handleChange = useCallback((_: any, isExpanded: boolean) => {
    setExpandedAcc(isExpanded)
  }, [])

  return (
    <Accordion expanded={expandedAcc} onChange={handleChange} sx={ACCORDION_SX} {...rest}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{subtitle}</AccordionDetails>
    </Accordion>
  )
}

AccordionUsage.defaultProps = {
  subtitle: null,
  expanded: false,
}

export default memo(AccordionUsage)


